module.exports = __webpack_public_path__ + "img/phone1.8fcd1495.png";